import { Trash2 } from "lucide-react"
import React from "react"

/**
 * DeleteButton Component
 *
 * A button component that displays a trash icon, typically used for delete actions.
 *
 * @component
 * @param {Object} props - The properties that define the component behavior.
 * @param {string} [props.id] - The optional ID for the button element.
 * @param {Function} [props.onClick] - The function to execute when the button is clicked.
 * @param {boolean} [props.disabled=false] - Determines whether the button is disabled.
 *
 * @returns {JSX.Element} The rendered DeleteButton component.
 */
interface DeleteButtonProps {
  id: string
  onClick?: () => void
  disabled?: boolean
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
  id,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      data-automation-id={id}
      id={id}
      onClick={onClick}
      disabled={disabled}
      className={`text-red-600 hover:text-red-900 ${disabled ? "cursor-not-allowed" : ""
        }`}
    >
      <span
        className={`inline-flex items-center justify-center w-8 h-8 bg-gray-200 rounded-full ${disabled ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-300"
          }`}
      >
        <Trash2 size={16} />
      </span>
    </button>
  )
}

export default DeleteButton
